import axios from 'axios'
import React, { useState, useEffect } from 'react'
import ButtonInput from 'components/elements/ButtonInput'
import InputColForm from 'components/inscriptionform/InputColForm'
import DatePicker, { registerLocale } from 'react-datepicker';
import Select from 'react-select';
import Checkbox from '@mui/material/Checkbox';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import Moment from 'moment';
import AlertSuccess from 'components/alerts/AlertSuccess'
import CategoriePaper from 'components/elements/CategoriePaper';
import ModalRules from 'pages/PreinscriptionForm/components/ModalRules';
import ModalInscription from 'pages/PreinscriptionForm/components/ModalInscription';
import FileUpload from 'react-material-file-upload';
import { red } from '@mui/material/colors';
import { BankAccount } from 'components/elements/BankAccount';
registerLocale('es', es);

/**
 * @description Componente que renderiza el formulario de inscripción
 * @param {Object} props - component props
 * @param {Object} props.category - categoría de la carrera
 * @returns {Object} - Retorna el formulario de inscripción
 * 
 */

/** 
 * @param url - url de la api
 * */ 
// const endpoint = 'http://127.0.0.1:8000/api/inscription'
//const endpoint = 'https://uncoactiva-back.fi.uncoma.edu.ar/api/inscription'
const endpoint = process.env.REACT_APP_BACKEND_URL+'/inscription'

const sizes = [
  { value: 'XS', label: 'XS' },
  { value: 'S', label: 'S' },
  { value: 'M', label: 'M' },
  { value: 'L', label: 'L' },
  { value: 'XL', label: 'XL' },
  { value: 'XXL', label: 'XXL' }
];
const genders = [
  { value: 'Masculino', label: 'Masculino' },
  { value: 'Femenino', label: 'Femenino' },
  { value: 'X', label: 'X' },
  // { value: 'No se', label: 'No se' }
];

export const expresiones = {
  address: /^[a-zA-ZÀ-ÿ-Z0-9_-\s\W]{4,100}$/, // Letras, numeros, y caracteres especiales
  name: /^[a-zA-ZÀ-ÿ\s]{3,50}$/, // Letras y espacios, pueden llevar acentos.
  dni: /^\d{7,8}$/, // 7-8 digitos.
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phone: /^\d{7,14}$/ // 7 a 14 numeros.
}

//Inicia Componente
const PreinscriptionForm = (props) => {

  // const { user } = useAuth({ middleware: 'auth' })
  // if (!user) {
  //   window.location.pathname = '/login'
  // }

  const [opensucces, setopensucces] = useState(false);
  const [openfail, setopenfail] = useState(false);
  const [name, setname] = useState({ campo: '', valido: null })
  const [surname, setsurname] = useState({ campo: '', valido: null })
  const [gender, setgender] = useState({ campo: '', valido: null })
  const [birth, setbirth] = useState({ campo: null, valido: null })
  const [dni, setdni] = useState({ campo: '', valido: null })
  const [email, setemail] = useState({ campo: '', valido: null })
  const [country, setcountry] = useState({ campo: '', valido: null })
  const [province, setprovince] = useState({ campo: '', valido: null })
  const [city, setcity] = useState({ campo: '', valido: null })
  const [address, setaddress] = useState({ campo: '', valido: null })
  const [phone, setphone] = useState({ campo: '', valido: null })
  const [social_work, setsocial_work] = useState({ campo: '', valido: null })
  const [shirt_size, setshirt_size] = useState({ campo: '', valido: null })
  const [emergency_contac_name, setemergency_contac_name] = useState({ campo: '', valido: null })
  const [emergency_contac_phone, setemergency_contac_phone] = useState({ campo: '', valido: null })
  const [emergency_contac_bond, setemergency_contac_bond] = useState({ campo: '', valido: null })
  const [checked, setChecked] = useState(null);
  const [openrules, setopenrules] = useState(false);
  const [openInscription, setopenInscription] = useState(false)
  const [errorMessage, seterrorMessage] = useState('');
  
  const [isUniversityMember, setIsUniversityMember] = useState(null); // null, 'yes', 'no'
  const [dniToCheck, setDniToCheck] = useState('');
  const [dniStatus, setDniStatus] = useState('normal'); //'community'/'normal'

  const [files, setFiles] = useState([]);
  const [filevalidation, setfilevalidation] = useState({ campo: 'Debes enviar el comprobante, sin el no se te considerará como inscripto en la carrera.', valido: null });

  /**
   * @description Verifica si la fecha actual es mayor a la de la carrera
   * @returns {boolean} true si la fecha actual es mayor a la de la carrera, false en caso contrario
   */
  
  const now = Date.now();
  
  const isInscriptionLimit = now > new Date('April 24, 2026 10:30:00'); //Fecha/Hora límite de inscripcion (antes del dia de la carrera)

  const [openEnd, setopenEnd] = useState(isInscriptionLimit);

  const [alertnavigate, setalertnavigate] = useState(false);

// valores MP
  const linkMP = [
    { race: '3k', 
      link: 'https://mpago.la/2xpW5Vt', 
      comunityLink:'https://mpago.la/1r1xhe8',
    },
    { 
      race: '7k', 
      link: 'https://mpago.la/2Bqb3sr', 
      comunityLink: 'https://mpago.la/2xjQB7t' 
    },
    { 
      race: '15k', 
      link: 'https://mpago.la/2W1AVwo', 
      comunityLink: 'https://mpago.la/1ok1Xqx' 
    },
  ]
    
  const [comunidadUncoDnis, setComunidadUncoDnis] = useState([]);
  
  useEffect(() => {
    fetch('/sorted_dnis.json')
      .then((response) => 
        response.json()
      )
      .then((data) => 
        setComunidadUncoDnis(data.dnis || []))
      .catch((error) => {
        // console.error('Error al cargar el archivo JSON:', error)
      });
  }, []);
  
  const checkDNIComunidad = (dni) => {
    const formattedDni = dni.toString();

    const binarySearch = (array, target) => {
      let low = 0;
      let high = array.length - 1;
    
      while (low <= high) {
        const mid = Math.floor((low + high) / 2);
        const guess = array[mid].toString();  
    
        if (guess === target) {
          return true;
        }
        if (guess > target) {
          high = mid - 1;
        } else {
          low = mid + 1;
        }
      }
      return false;
    };

    return binarySearch(comunidadUncoDnis, formattedDni) ? 'community' : 'normal';
  };
  
  const handleResponse = (response) => {
    setIsUniversityMember(response); // 'yes' o 'no'
    if(response === 'no') {
      setDniStatus('normal'); // Si no es parte de la comunidad, no hace falta verificar el DNI
    }
  };

  const handleDniCheck = () => {
    const isCommunity = checkDNIComunidad(dniToCheck);
    setDniStatus(isCommunity);
    setdni({campo: dniToCheck, valido: 'true'});
  };

  const CategoriaButton = ({ categoria }) => {
    const enlaceBase = linkMP.find(item => item.race === categoria);
    let enlace;
  
    if (enlaceBase) {
      const tipoUsuario = dniStatus;
  
      // Elegir el enlace adecuado
      if(tipoUsuario === 'community')
        enlace = enlaceBase.comunityLink;
      else
        enlace = enlaceBase.link;
      return (
        <a href={enlace} target="_blank" rel="noreferrer">
          <button type="button" className="bg-blue-cyan hover:bg-blue-cyan-dark text-white-unco font-bold py-2 px-4 rounded-md">
            Pagar por MercadoPago
          </button>
        </a>
      );
    } else {
      return null; // Si no se encuentra el enlace para esa categoría
    }
  };
  
  const arraycampos = [
    [checked, setChecked],
    [name, setname],
    [surname, setsurname],
    [gender, setgender],
    [birth, setbirth],
    [dni, setdni],
    [email, setemail],
    [country, setcountry],
    [province, setprovince],
    [city, setcity],
    [address, setaddress],
    [phone, setphone],
    [shirt_size, setshirt_size],
    [emergency_contac_name, setemergency_contac_name],
    [emergency_contac_bond, setemergency_contac_bond],
    [emergency_contac_phone, setemergency_contac_phone],
    [filevalidation, setfilevalidation],
    [emergency_contac_phone, setemergency_contac_phone]
  ]

  // const csrf = () => axios.get('/sanctum/csrf-cookie')

  const storeInscription = async (e) => {
    e.preventDefault()
    // //console.log(e)
    // //console.log(arraycampos)

    // console.log(e)
    var formularioValido = true
    // console.log(arraycampos)
    // eslint-disable-next-line array-callback-return
    arraycampos.map((campo) => {
      let estado = campo[0]
      let cambiarEstado = campo[1]

      if ((checked == null || checked === false) && formularioValido) {
        setChecked(false);
        formularioValido = false
      }
      else if ((estado.valido === null || estado.valido === 'false')) {
        formularioValido = false
        cambiarEstado({ ...estado, valido: 'false' });
      }
    })    
    // console.log(files)
    // console.log(formularioValido)
    if (formularioValido) {
      if (phone.campo === emergency_contac_phone.campo) {
        seterrorMessage('Ingrese un número de contacto de emergencia que sea diferente al suyo porfavor')
        setopenfail(true)
      }
      else if (isInscriptionLimit){
        seterrorMessage('Ya no está disponible la carrera')
        setopenfail(true)
      }
      else {
        setopenInscription(true)
      }
    }
    else {
      seterrorMessage('Complete todos los campos porfavor')
      setopenfail(true)
      // console.log('no se envio')
    }
  }

  const submitInscription = async () => {
    let formatDate = Moment(birth.campo).format('YYYY-MM-DD')
    const formdata = new FormData();
    
    for (let i = 0; i < files.length; i++) {
      // console.log('imagen' + i, files[i] )
      formdata.append('files[]', files[i]);
    }

    // console.log('category', props.category.id)
    formdata.append('name', name.campo);
    formdata.append('race_categorie_id', props.category.id);
    formdata.append('surname', surname.campo);
    formdata.append('gender', gender.campo);
    formdata.append('birth', formatDate);
    formdata.append('dni', dni.campo);
    formdata.append('email', email.campo);
    formdata.append('country', country.campo);
    formdata.append('province', province.campo);
    formdata.append('city', city.campo);
    formdata.append('address', address.campo);
    formdata.append('phone', phone.campo);
    formdata.append('social_work', social_work.campo);
    formdata.append('shirt_size', shirt_size.campo);
    formdata.append('emergency_contac_name', emergency_contac_name.campo);
    formdata.append('emergency_contac_bond', emergency_contac_bond.campo);
    formdata.append('emergency_contac_phone', emergency_contac_phone.campo);

    // console.log('datos', formdata);
    await axios.post(endpoint, formdata)
      .then(function (response) {
        // console.log('success store', response);
        setopenInscription(false)
        setopensucces(true)
  

        //window.location.reload(false);
      })
      .catch(function (error) {
        setopenInscription(false)
        setalertnavigate('/')
        seterrorMessage(error.response.data.message)
        setopenfail(true)
        // console.error('error store', error.response.data.message);
      });
  }

  const handleClickOpenRules = () => {
    setopenrules(true);
  };

  var datebirthlimit = new Date();
  // datebirthlimit.setFullYear(datebirthlimit.getFullYear() - 18);

  const validaciondate = () => {
    if (birth.campo === null) {
      setbirth({ ...birth, valido: 'false' });
      // console.log('invalido', birth)
    } else {
      setbirth({ ...birth, valido: 'true' });
      // console.log('valido', birth)
    }
  }

  const validargenero = () => {

    if (gender.campo === '') {
      setgender({ ...gender, valido: 'false' })
      // console.log('invalido', gender)
    } else {
      setgender({ ...gender, valido: 'true' })
      // console.log('valido', gender)
    }
  }

  const validarsize = () => {
    if (shirt_size.campo === '') {
      setshirt_size({ ...shirt_size, valido: 'false' })
      // console.log('invalido', shirt_size)
    } else {
      setshirt_size({ ...shirt_size, valido: 'true' })

    }
  }
  const handlechangeGender = (e) => {
    gender.campo = e.value
  }

  const colorstylesSizes = {
    control: (styles) => ({
      ...styles, borderColor: shirt_size.valido === 'false' ? 'red ' : 'gray-darker',
      boxShadow: shirt_size.valido === 'false' ? '0px 0.0 1em 0px 0px red' : '0px 0px 0px 0px rgb(0 170 225)',
      borderWidth: '0',
      borderBottomWidth: '2px',
      backgroundColor: 'transparent',
      '&:hover': {
        boxShadow: '0px 1px 0px 0px rgb(0 170 225)'
      }
    }),
    placeholder: (base) => ({
      ...base,
      // backgroundColor: 'black',
      marginLeft: '-0.5em',
      fontSize: '1.1em',
      color: 'gray-darker',
      fontWeight: 400
    })
  }

  const onChangeTerminos = (e) => {
    setChecked(e.target.checked);
  }

  const onChangeFile = (e) => {

    // console.log(e)
    let array = []
    array[0] = e[0];
    setfilevalidation({ valido: true })
    if (e.length === 0) {
      setfilevalidation({
        ...filevalidation,
        campo: 'Debe enviar el comprobante, sin el no se te considerará como inscripto en la carrera.',
        valido: 'false'
      })
      // console.log('invalido', e)
      setFiles(e);
    }
    else {
      if ((array[0].type.indexOf('image') !== -1) || (array[0].type.indexOf('application/pdf') !== -1)) {
        // console.log('tipo imagen', array[0].type, array[0].type.indexOf('image'))
      }
      else {
        setfilevalidation({ ...filevalidation, campo: 'Formato de archivo inválido, formatos admitidos: png, jpg, pdf', valido: 'false' })
      }
      if (array[0].size > 2097152) {
        setfilevalidation({ ...filevalidation, campo: 'Tamaño máximo de archivo excedido: 2MB', valido: 'false' })
        // console.log('invalido', array[0].size)
      }
      setFiles(array);
    }
  }

  return (    
    <div className='flex flex-col rounded-md h-full w-full py-10'>
      <div className='flex flex-col h-full w-3/4 lg:max-w-7xl p-6 m-auto bg-neutral-100 rounded-md shadow-md items-center'>
        <div>
          <img alt='Imagotipo UNCo Activa' className='w-32' src='/logos/uncoActiva/imagotipo/UNCo Activa 2026 Celeste.svg'></img>
        </div>
        <div className='grid sm:grid-cols-1 justify-center items-center'>
          
          <h1 className='text-3xl font-bold text-center my-5 text-gray-darker font-Header-B'>
            Formulario de preinscripción
          </h1>
          <div className='flex justify-center items-center'>
            <CategoriePaper boxShadow='none' color={props.category.color} name={props.category.name}> </CategoriePaper>
          </div>
        </div>
        
        <AlertSuccess open={openEnd} onClose={setopenEnd}
          bg=' rgb(240 240 240)'
          titlecolor='warning.main'
          title={
            <span className="font-Header-B">
              ¡Atención!
            </span>
          }
          description={
            <div className="flex flex-col gap-6">
              <p>
                <span className="text-[1.6rem] font-Text-R font-bold flex">
                Las inscripciones están cerradas. Por favor, no realizar transferencias. No nos responsabilizamos por inscripciones fuera de término.
                </span>
              </p>
            </div>
          }
        />
        <AlertSuccess open={opensucces} onClose={setopensucces}
          bg=' rgb(240 240 240)'
          titlecolor='success.main'
          title={
            <span className="font-Header-B">
              ¡Registro Exitoso!
            </span>
          }
          navigate='/'
          description='Ha completado el registro con éxito. Por favor, verifique su bandeja de entrada y la carpeta de SPAM.'
        />
        <AlertSuccess open={openfail} onClose={setopenfail}
          bg=' rgb(240 240 240)'
          titlecolor='warning.main'
          title={
            <span className="font-Header-B">
              ¡Advertencia!
            </span>
          }
          navigate={alertnavigate}
          description={errorMessage}
        />

        {isUniversityMember === null ? (
          // Preguntar si pertenece a la comunidad universitaria
          <div className="flex flex-col items-center justify-center mt-4 gap-4">
            <p className="text-xl font-semibold text-center">¿Pertenece a la comunidad universitaria?</p> {/* Aumentar tamaño de texto y centrar */}
            <button 
              className="bg-blue-500 text-white w-16 py-2 rounded-lg hover:bg-blue-700 transition duration-200"
              onClick={() => handleResponse('yes')}
            >
              Sí
            </button>
            <button 
              className="bg-blue-500 text-white w-16 py-2 rounded-lg hover:bg-blue-700 transition duration-200"
              onClick={() => handleResponse('no')}
            >
              No
            </button>
          </div>
        ) : isUniversityMember === 'yes' ? (
          // Si es miembro de la comunidad, pedir el DNI
          <div className="flex flex-col items-center justify-center gap-4 px-2 md:px-6 text-center">
            <p className="text-xl font-semibold text-center">Por favor, ingrese su DNI:</p> {/* Aumentar tamaño de texto y centrar */}
            <input
              type="text" 
              value={dniToCheck} 
              onChange={(e) => setDniToCheck(e.target.value)} 
              className="border-2 border-gray-300 px-4 py-2 rounded-lg"
            />
            <button 
              className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-200"
              onClick={handleDniCheck}
            >
              Verificar DNI
            </button>
            
            {dniStatus && (
              <p>{dniStatus === 'community' ? 'DNI válido para comunidad universitaria. ' : 'DNI no reconocido como parte de la comunidad. Si se trata de un error, por favor contactarse con nosotros a uncoactiva@gmail.com.'}</p>
            )}
          </div>
        ) : null}

        {isUniversityMember !== null && dniStatus !== null &&(
        <form onSubmit={storeInscription} autoComplete='false' className='grid grid-cols-1 md:grid-cols-2 md:gap-6 py-6 w-full'>

          <InputColForm
            regularExpression={expresiones.name}
            value={name}
            onChange={setname}
            type='text'
            id='name'
            label='Nombre'
            error='Ingrese un nombre válido, mayor a 3 carácteres usando solo letras'
          />

          <InputColForm
            regularExpression={expresiones.name}
            type='text'
            id='surname'
            label='Apellido'
            value={surname}
            onChange={setsurname}
            error='Ingrese un apellido válido, mayor a 3 carácteres usando solo letras'
          />

          <div className='relative col-span-2  md:col-span-1 z-10 mb-7'>
            <DatePicker className={`block py-2.5 scroll-black px-0 w-full text-sm text-gray-darker bg-transparent border-0 border-b-2 dark:text-gray-darker focus:outline-none focus:ring-0 focus:border-blue-600 ${birth.valido === 'false' ? 'border-red-500 dark:border-red-500 dark:focus:border-red-500' : 'border-gray-dark  dark:border-gray-dark dark:focus:border-blue-500'}`}
              selected={birth.campo}
              id='birth'
              onChange={(date) => {
                setbirth({campo: date, valido: date ? 'true' : 'false' })
              }}
              dateFormat={'dd-MM-yyyy'}
              onKeyUp={validaciondate}
              onBlur={validaciondate}
              onKeyDown={(e)=> {
                if (e.key === '/') {
                  e.preventDefault();
                }
              }}
              placeholderText='Fecha de nacimiento'
              maxDate={props.category.name !== '3k' ? datebirthlimit : new Date()}
              showYearDropdown
              showMonthDropdown
              scrollableYearDropdown
              isClearable
              dropdownMode='select'
              wrapperClassName='text-red-500'
              calendarClassName='text-white'
              locale={'es'}
              autoComplete='off'
            />
            <p className={birth.valido === 'false' ? 'text-red-500 block' : 'invisible'}>
              Ingrese una fecha válida
              {/* , debe ser mayor de 18 años para poder inscribirse */}
            </p>
          </div>

          {isUniversityMember === 'no' && (
          <InputColForm
            regularExpression={expresiones.dni}
            type='number'
            id='dni'
            label='DNI'
            value={dni}
            onChange={setdni}
            error='Ingrese un DNI válido, de 7 u 8 dígitos'
          />)}

          <div className='col-span-2 mb-2 mt-1 md:col-span-1 text-gray-darker dark:text-gray-darker'>
            <Select
              placeholder='Género'
              styles={colorstylesSizes}
              name='gender'
              Value={gender}
              onChange={(e) => handlechangeGender(e)}
              onBlur={validargenero}
              options={genders}
              id='gender'
            />
            <p className={gender.valido === 'false' ? 'text-red-500 block' : 'invisible'}>
              Debe seleccionar un género
            </p>
          </div>

          <InputColForm
            regularExpression={expresiones.name}
            type='text'
            id='country'
            label='País'
            value={country}
            onChange={setcountry}
            error='Ingrese un país'
          />
  
          <InputColForm
            type='text'
            id='province'
            label='Provincia'
            value={province}
            onChange={setprovince}
            regularExpression={expresiones.name}
            error='Ingrese una provincia' 
          />

          <InputColForm type='text'
            id='city'
            label='Localidad'
            value={city}
            onChange={setcity}
            regularExpression={expresiones.name}
            error='Ingrese una provincia' 
          />
  
          <InputColForm
            regularExpression={expresiones.address}
            type='text'
            label='Dirección de domicilio'
            id='address'
            value={address}
            onChange={setaddress}
            error='Ingrese un domicilio válido, usando letras, números y carácteres especiales' 
          />

          <InputColForm
            regularExpression={expresiones.email}
            id='email'
            type='mail'
            label='Email'
            value={email}
            onChange={setemail}
            error='Ingrese un email válido' 
          />
  
          <InputColForm
            type='tel'
            id='phone'
            label='Número de teléfono'
            value={phone}
            onChange={setphone}
            regularExpression={expresiones.phone}
            error='Ingrese un teléfono válido' 
          />

          <InputColForm
            id='social_work'
            type='text'
            label='Obra social'
            value={social_work}
            onChange={setsocial_work} 
          />

          <div className='col-span-2 mb-2 mt-1 md:col-span-1 text-gray-darker dark:text-gray-darker'>
            <Select
              className='text-gray-darker col-span-2  md:col-span-1  dark:text-gray-darker'
              Value={shirt_size.campo}
              onChange={(e) => {
                shirt_size.campo = e.value
              }}
              styles={colorstylesSizes}
              onBlur={validarsize}
              options={sizes}
              id='shirt_size'
              placeholder='Talle de remera' 
            />

            <p className={shirt_size.valido === 'false' ? 'text-red-500 block' : 'invisible'}>
              Debe seleccionar un talle
            </p>
          </div>
  
          <div className='relative col-span-2 z-0 mb-2 mt-2 w-full group'>
            <span className='text-xl font-semibold dark:text-black'>
              Contacto en caso de emergencias
            </span>
          </div>
  
          <InputColForm
            type='text'
            label='Nombre y Apellido'
            id='emergency_contac_name'
            value={emergency_contac_name}
            onChange={setemergency_contac_name}
            regularExpression={expresiones.name}
            error='Ingrese un nombre válido, mayor a 3 carácteres usando solo letras'
          />

          <InputColForm
            type='text'
            id='emergency_contac_bond'
            label='Vínculo de contacto'
            value={emergency_contac_bond}
            onChange={setemergency_contac_bond}
            regularExpression={expresiones.name}
            error='Ingrese el vínculo de tu contacto de emergencia'
          />

          <InputColForm
            type='text'
            id='emergency_contac_phone'
            label='Número telefónico'
            value={emergency_contac_phone}
            onChange={setemergency_contac_phone}
            regularExpression={expresiones.phone}
            error='Ingrese un teléfono de contacto de emergencia'
          />
  
          {!isInscriptionLimit ? 
            <div className='relative col-span-2  z-0 mb-5 md:mb-1 -mt-1  w-full group'>
              <p>
                <strong>Modo de inscripción:</strong> El participante deberá inscribirse a la carrera por la web uncoactiva.fi.uncoma.edu.ar, realizando el pago, únicamente por transferencia bancaria o Mercadopago:
              </p>
                <BankAccount />
              <p>
                O MercadoPago en el siguiente link <CategoriaButton categoria={props.category.name} dni = {dni.campo}/>
              </p>
              <p>
                <strong>Categoría: </strong><strong style={{ color: props.category.color }}> {props.category.name}</strong>
                <br />
                <strong>Precio:</strong> ${dniStatus === 'community' ? props.category.promo : props.category.price}
                <br /><br />
                De no enviarse el comprobante de pago/transferencia con todos los datos de la operación en este formulario, no se considerará como inscripto.
              </p>
            </div> : ''}
          
          <div className="relative col-span-2 justify-items-center self-center z-0 lg:mx-20 mb-2">
            <FileUpload
              multiFile={false}
              maxUploadFiles={3}
              accept='image/*, application/pdf'
              sx={{
                '& .MuiOutlinedInput-root.Mui-disabled': { '& > fieldset': { border: '1px solid red' } },
                '& .MuiOutlinedInput-root:focus': {
                  '& > fieldset': {
                    borderColor: red[500]
                  }
                },
                '&:focus-within': {
                  boxShadow: filevalidation.valido === 'false' ? '0px 0px 0px 2px red' : '0px 0px 0px 2px rgb(0 170 225)'
                },
                '&:hover': {
                  boxShadow: filevalidation.valido === 'false' ? '0px 0px 0px 2px red' : '0px 0px 0px 2px rgb(0 170 225)'
                },
                '&:focus': {
                  boxShadow: filevalidation.valido === 'false' ? '0px 0px 0px 2px red' : '0px 0px 0px 2px rgb(0 170 225)'
                },
                boxShadow: filevalidation.valido === 'false' ? '0px 0px 0px 2px red' : '0px 0px 0px 0px rgb(0 170 225)'
              }}
              title='Suba el comprobante de pago aquí. Solo imágenes o pdf con tamaño máximo de 2MB'
              buttonText='Subir comprobante'
              value={files}
              onChange={(e) => onChangeFile(e)} />
            <p className={filevalidation.valido === 'false' ? 'flex text-red-500 justify-center mt-1' : 'invisible'}>
              {filevalidation.campo}               
            </p>
          </div>
  
          <div className='relative col-span-2 justify-self-center z-0 -mt-1 -ml-3 w-full group'>
            <Checkbox
              sx={{marginLeft: -1}}
              checked={checked}
              onChange={(e) => onChangeTerminos(e)}
              inputProps={{ 'aria-label': 'uncontrolled' }}
              id='check'
            />
            <label htmlFor={'check'} className='dark:text-gray-darker -mt-1 text-gray-darker'>{'Acepto los términos y condiciones del '}
              <button type='button' onClick={handleClickOpenRules} className='text-blue-cyan '>
                Reglamento de la carrera
              </button> 
            </label>
            <p className={checked === false ? 'text-red-500 block' : 'invisible'}>
              Debe aceptar los términos y condiciones 
            </p>
          </div>
  
          <div className='relative col-span-2 mt-3 md:-mt-1 mb-3 md:mb-0 flex-none w-24 ...'>
            <ButtonInput type='submit' text='Enviar' divclass='lg:w-28 md:w-28 sm:w-auto flex-none' />
          </div>
          <div className='relative col-span-1 md:col-span-2'>
            <p className='text-ellipsis dark:text-gray-darker ml-1 text-gray-darker '>
              {'Por cualquier duda o inconveniente acerca de la carrera, consular al mail de '}
              <a href={'mailto:uncoactiva@gmail.com'} className='text-blue-cyan'>
                UncoActiva
              </a>
            </p>
          </div>
        </form>
        )}

        <ModalRules open={openrules} onClose={setopenrules}
          category={props.category}
          bg=' rgb(240 240 240)'
          titlecolor=''
          title='REGLAS GENERALES PARA LOS PARTICIPANTES'
        />

        { dniStatus ? (
        <ModalInscription
          submitInscription={submitInscription}
          loading={opensucces}
          category={props.category}
          setopenInscription={setopenInscription}
          openInscription={openInscription}
          validemail={email.valido}
          dniStatus={dniStatus}
          filevalid={filevalidation.valido} 
        />) : ''}

      </div>
    </div>
  );
  
}

export default PreinscriptionForm